// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__SEr0m","page":"Pagination_page__DQ_e4","active":"Pagination_active__5Ws95"};